// 3rd party
import * as React from 'react';
import { observer } from 'mobx-react';

// Bernie
import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';

// Hooks
import { useStores } from 'hooks';

interface MoreInformationDialogProps {
  id: string;
  title?: string;
  description?: string | string[];
  children?: React.ReactNode;
  onOpen?: () => void;
  onDismiss?: () => void;
  onClose?: () => void;
  onCloseButtonClick?: () => void;
}

const MoreInformationDialog = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function MoreInformationDialog(props: MoreInformationDialogProps) {
    const { id, title, description, children, onOpen, onDismiss, onClose, onCloseButtonClick } = props;

    const l10n = useLocalization();
    const { routeStore } = useStores();

    function handleDialogOpen() {
      // TODO: Add dialog open tracking

      onOpen?.();
    }

    function handleDialogClose() {
      // TODO: Add dialog close tracking

      routeStore.closeDialog();

      onClose?.();
    }

    function handleDialogDismiss() {
      // TODO: Add dialog dismiss tracking

      onDismiss?.();

      handleDialogClose();
    }

    function handleDialogCloseButtonClick() {
      // TODO: Add dialog close button click tracking

      onCloseButtonClick?.();

      handleDialogClose();
    }

    const dialogId = `more-information-${id.toLowerCase()}`;

    const descriptionParts = (!Array.isArray(description) ? [description] : description).filter(Boolean);

    return (
      <DialogRoute id={dialogId}>
        <Layer id="dialogMoreInformation" onDismiss={handleDialogDismiss}>
          <UitkDialog
            dialogShow={true}
            returnFocusOnClose={true}
            openCallback={handleDialogOpen}
            closeCallback={handleDialogClose}
          >
            <UitkDialogContent>
              {title && (
                <UitkHeading tag="h3" size={5}>
                  {title}
                </UitkHeading>
              )}

              {description &&
                descriptionParts.map((descriptionPart, index) => (
                  <UitkParagraph key={index} size={1}>
                    {descriptionPart}
                  </UitkParagraph>
                ))}

              {children}
            </UitkDialogContent>

            <UitkDialogFooter
              buttonOne={{
                type: 'tertiary',
                text: l10n.formatText('common.dialog.close'),
                onClick: handleDialogCloseButtonClick,
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    );
  },
);

export { MoreInformationDialog };
